module.exports = __webpack_public_path__ + "static/media/il.71dbb460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/il.svg
// module id = 148
// module chunks = 0